export const getCircularImage = (croppedImage, diameter = 100) => {
  return new Promise((resolve) => {
    const resultCanvas = document.createElement("canvas");
    const ctx = resultCanvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      const size = Math.min(img.width, img.height, diameter);
      resultCanvas.width = size;
      resultCanvas.height = size;

      ctx.clearRect(0, 0, size, size);
      ctx.save();

      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 4, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();

      ctx.drawImage(img, 0, 0, size, size);
      ctx.restore();

      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 2, 0, Math.PI * 2);
      ctx.strokeStyle = "#800080";
      ctx.lineWidth = 2;
      ctx.stroke();

      resolve(resultCanvas.toDataURL("image/png"));
    };

    img.src = croppedImage;
  });
};
